// extracted by mini-css-extract-plugin
export var description = "NavPanel-module--description--0b400";
export var heading = "NavPanel-module--heading--252a1";
export var isReverse = "NavPanel-module--isReverse--01acf";
export var navPanel = "NavPanel-module--navPanel--337cc";